module.exports = __webpack_public_path__ + "img/logo_sub_nav.d42e21f0.png";